import { type JSX, onCleanup, onMount } from "solid-js";

export function MapModalSheet(props: {
  id: string;
  kicker: string;
  title: string;
  closeLabel: string;
  returnFocus: HTMLElement | null;
  onClose: () => void;
  children: JSX.Element;
}) {
  let panel: HTMLElement | undefined;
  let closeButton: HTMLButtonElement | undefined;
  onMount(() => queueMicrotask(() => closeButton?.focus()));
  onCleanup(() => queueMicrotask(() => props.returnFocus?.focus()));
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      event.stopPropagation();
      props.onClose();
      return;
    }
    if (event.key !== "Tab" || !panel) return;
    const controls = focusableControls(panel);
    const first = controls[0];
    const last = controls.at(-1);
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };
  return (
    <div class="map-sheet-layer">
      <button
        type="button"
        class="map-sheet-scrim"
        aria-label={props.closeLabel}
        onClick={props.onClose}
      />
      <aside
        ref={panel}
        class="map-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby={`${props.id}-title`}
        onKeyDown={onKeyDown}
      >
        <header class="map-sheet-head">
          <div>
            <span class="signal-mini-kicker">{props.kicker}</span>
            <h2 id={`${props.id}-title`}>{props.title}</h2>
          </div>
          <button
            ref={closeButton}
            type="button"
            class="map-sheet-close"
            title={props.closeLabel}
            aria-label={props.closeLabel}
            onClick={props.onClose}
          >
            x
          </button>
        </header>
        <div class="map-sheet-body">{props.children}</div>
      </aside>
    </div>
  );
}

function focusableControls(root: HTMLElement): HTMLElement[] {
  return [
    ...root.querySelectorAll<HTMLElement>(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    ),
  ].filter((element) => !element.hasAttribute("hidden"));
}
